import ContactFormSection from "../Components/ContactFormSection";

function Contact() {
  return (
    <div className="section-wrap py-10 lg:py-14">
      <ContactFormSection
        className="mx-auto max-w-5xl"
        title="CONTACT FORM"
        
      />
    </div>
  );
}

export default Contact;
